import React, { useState } from 'react'

import SVG from 'react-inlinesvg'

const pinStyle = {
  fill: '#6200EE',
  stroke: 'none'
};


const lookUpIcon = (category) => {
  const svgName = category.toLowerCase()
  //console.log(`Look up icon for `, category, svgName);

  const swapIcons = {
    'entertainment': 'art',
    'restaurant': 'food',
    'activism': 'community',
    'drinking': 'drink',
    'health': 'fitness',
    'services': 'community',
    'visit': 'entertainment'
  };

  return swapIcons[svgName] || svgName
}


const Icon = ({
  category,
  color = '#444444',
  height = 20,
  width = 20,
  style = {},
  onError = () => {},
  ...props
}) => {

  const svgIcon = category && lookUpIcon(category)
  let svgPath = '/assets/icons/' + svgIcon + '.svg'

  return (
      <SVG
        fill={color}
        src={svgPath}
        height={height}
        width={width}
        style={style}
        onError={(error) => onError(error)}
        />
  )
}

export default Icon